import { createContext } from 'react';

export const AgentContext = createContext({
  agents: [],
  agent: {},
});
